import { useQuery } from "@tanstack/react-query";

import { getTags } from "../../services/tags";

const useGetTags = (enabled: boolean) => {
    return useQuery({
        queryKey: ['tags'],
        queryFn: getTags,
        staleTime: Infinity,
        retry: 0,
        enabled,
    });
};

export default useGetTags;